import { Component } from "@angular/core";

@Component({
  selector: "app-administration",
  templateUrl: "./administration.component.html",
  styleUrls: ["./administration.component.scss"]
})
export class AdministrationComponent {
  isShowDropdown: boolean;

  constructor() { 
    this.isShowDropdown = false;
  }

}


// WEBPACK FOOTER //
// ./src/app/administration/administration.component.ts